export default {
  'calander.guide': 'Guida al calendario',
  'calander.redtheme': 'Colore rosso',
  'calander.graytheme': 'Colore grigio',
  'calander.greentheme': 'Colore verde',
  'calander.bluetheme': 'Colore blu',
  'calander.guidetitle':
    'I colori delle occasioni sotto il calendario sono i seguenti.',
  'calander.redthemeguide':
    'Questo colore indica le festività ufficiali secondo il paese selezionato.',
  'calander.graythemeguide':
    'Questo colore indica le occasioni religiose del paese selezionato.',
  'calander.greenthemeguide':
    'Questo colore indica le occasioni native del paese selezionato.',
  'calander.bluethemeguide': `Questo colore indica l'occasione locale tradizionale del paese selezionato.`,
  'calander.selectCountry': 'Nome del paese in cui visualizzare gli eventi',
  'calander.changeDate': 'Cambia data',
  'calander.changeType': 'Cambia Tipo',
  'calander.shamsi': 'Shamsi',
  'calander.miladi': 'Miladi',
  'calander.hijri': 'Hijri',
  'otheroption.otheroptions': 'Altre Opzioni',
  'calendar.calculateDate': 'Calcoli delle date',
  'otheroption.departuredate': 'Data di Partenza',
  'otheroption.returndate': 'Data di Ritorno',
  'otheroption.dayscount': 'Conteggio Giorni',
  'otheroption.calculate': 'Calcolare',
  'otheroption.timeinterval': 'Intervallo di tempo (età)',
  'otheroption.alertinsertresult.it': 'La data inserita non è valida.',
  'otheroption.untiltodayfuture': 'Tempo rimanente da oggi.',
  'otheroption.untiltodaypast': 'Tempo trascorso fino ad oggi.',
  'otheroption.otheroptionsguide1':
    'Selezionando un paese nella parte superiore del calendario, vengono impostati gli eventi specifici per quel paese.',
  'otheroption.otheroptionsguide2':
    'Passando il cursore su un giorno, qualsiasi evento per quel giorno verrà visualizzato in basso al calendario.',
  'otheroption.otheroptionsguide3':
    "Facendo clic su due date, verrà visualizzato l'intervallo di tempo tra di esse.",
  'otheroption.otheroptionsguide4':
    'Tutti gli eventi del calendario sono forniti in formato elenco nella sezione eventi del calendario.',
};
